export default "__VITE_ASSET__a1e9923f__"